import React, {useEffect, useContext} from "react";
import LoaderAnim from "../../components/LoaderAnim/index";
import {useDataApi, API} from "../../components/API/index";
import Context, {Actions} from "../../reducers/Context";
import NavButton from "../../components/NavButton";

const SingleTeam = props => {
    const {dispatch, state} = useContext(Context);
    const {data, isLoading, isError, doFetch} = useDataApi("");

    useEffect(() => {
        if (state.loginTeams) {
            const team = state.loginTeams[0];
            dispatch({
                type: Actions.SELECTED_TEAM,
                payload: team
            });
            doFetch(API.CREATE_SESSION, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({auth: state.auth, team})
            });
        }
    }, [state.loginTeams]);

    useEffect(() => {
        if (data) {
            //console.log("got data", data);
            dispatch({
                type: Actions.RECEIVED_SESSION_DATA,
                payload: data
            });
        }
    }, [data]);

    return (
        <>
            {(isLoading && <h1>LOADING</h1>)}
        </>
    );
};


export default {
    id: "single-team",
    title: "Logging you in...",
    subtitles: [""],
    imageUrl:
        "https://www.teamstats.net/teamstats-media/images/signup-form/squad-blurred.jpg",
    component: SingleTeam
};
